export const featuredComics = [
  {
    id: 'solo-leveling',
    title: '我独自升级',
    altTitle: 'Solo Leveling',
    author: 'Chugong / 张成乐',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20blue%20eyes%20wielding%20a%20dagger%20in%20a%20dark%20dungeon%20setting%20with%20purple%20magical%20energy%20swirling%20around%20him%20dramatic%20lighting%20epic%20composition%20clean%20background&width=400&height=560&seq=comic-cover-001&orientation=portrait',
    rating: 9.8,
    description: '十年前，被称为"人类最弱兵器"的成肖宇在一次地下城探索中濒临死亡，却意外获得了"系统"的能力，成为唯一可以"升级"的猎人。从此，他从最弱一步步走向最强...',
    status: '连载中',
    latestChapter: '第189话',
    views: 12500000,
    tags: ['热血', '奇幻', '战斗'],
    updateTime: '2026-07-02',
  },
  {
    id: 'tower-of-god',
    title: '神之塔',
    altTitle: 'Tower of God',
    author: 'SIU',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20boy%20with%20brown%20hair%20climbing%20a%20massive%20tower%20with%20golden%20geometric%20patterns%20floating%20in%20the%20sky%20fantasy%20atmosphere%20warm%20golden%20lighting%20vertical%20composition%20clean%20simple%20background&width=400&height=560&seq=comic-cover-002&orientation=portrait',
    rating: 9.6,
    description: '二十五夜为了追寻唯一的挚友蕾哈尔，进入了神之塔。这座塔的每一层都有着不同的世界和考验，登顶者可以实现任何愿望。而这座塔的秘密远比他想象的更加深邃...',
    status: '连载中',
    latestChapter: '第578话',
    views: 9800000,
    tags: ['奇幻', '冒险', '友情'],
    updateTime: '2026-07-01',
  },
  {
    id: 'lookism',
    title: '外貌至上主义',
    altTitle: 'Lookism',
    author: '朴泰俊',
    category: '校园',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20high%20school%20boy%20in%20school%20uniform%20standing%20in%20front%20of%20a%20mirror%20with%20a%20different%20reflection%20dual%20identity%20concept%20modern%20school%20setting%20dramatic%20lighting%20clean%20composition&width=400&height=560&seq=comic-cover-003&orientation=portrait',
    rating: 9.5,
    description: '朴亨锡是一个因为外貌而备受欺凌的高中生。某天醒来，他发现自己拥有了另一具完美的身体。白天他是校园里的人气王，晚上又变回原来的自己，两个身份之间的生活让他逐渐看清了这个以外貌论人的世界...',
    status: '连载中',
    latestChapter: '第452话',
    views: 8700000,
    tags: ['校园', '剧情', '成长'],
    updateTime: '2026-07-02',
  },
  {
    id: 'god-of-highschool',
    title: '高校之神',
    altTitle: 'The God of High School',
    author: '朴龙济',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20martial%20artist%20with%20spiky%20black%20hair%20in%20a%20fighting%20stance%20surrounded%20by%20fiery%20orange%20energy%20martial%20arts%20tournament%20theme%20dramatic%20action%20pose%20clean%20simple%20background&width=400&height=560&seq=comic-cover-004&orientation=portrait',
    rating: 9.4,
    description: '一场全国高中生格斗大赛拉开帷幕，来自全国各地的武术高手齐聚一堂。陈毛利以"最强高中生"为目标参赛，却发现这场比赛的背后隐藏着远超想象的巨大阴谋...',
    status: '已完结',
    latestChapter: '第569话',
    views: 8200000,
    tags: ['热血', '格斗', '奇幻'],
    updateTime: '2026-06-28',
  },
  {
    id: 'true-beauty',
    title: '女神降临',
    altTitle: 'True Beauty',
    author: 'Yaongyi',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20wavy%20hair%20applying%20makeup%20in%20front%20of%20a%20vanity%20mirror%20with%20cosmetic%20products%20soft%20romantic%20lighting%20elegant%20pink%20and%20peach%20tones%20clean%20composition&width=400&height=560&seq=comic-cover-005&orientation=portrait',
    rating: 9.3,
    description: '因为外貌自卑的林周京通过化妆技巧华丽变身，成为校园里的"女神"。但素颜的秘密不能被人发现，尤其是那两个同时闯入她生活的完美男生——高冷学霸李修浩和痞帅校草韩书俊...',
    status: '已完结',
    latestChapter: '第236话',
    views: 11000000,
    tags: ['恋爱', '校园', '喜剧'],
    updateTime: '2026-06-25',
  },
  {
    id: 'eleceed',
    title: '幻象异能',
    altTitle: 'Eleceed',
    author: '孙济浩 / ZHENA',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20cool%20Korean%20manhwa%20style%20illustration%20of%20a%20teenage%20boy%20with%20silver%20white%20hair%20surrounded%20by%20electric%20blue%20lightning%20sparks%20with%20a%20cute%20fat%20cat%20beside%20him%20superpower%20theme%20dynamic%20energy%20clean%20simple%20background&width=400&height=560&seq=comic-cover-006&orientation=portrait',
    rating: 9.6,
    description: '拥有闪电超能力的少年姜智宇，一直隐藏着自己的能力过着平凡生活。直到他遇见了同样拥有超能力的神秘组织成员，他的世界从此天翻地覆...',
    status: '连载中',
    latestChapter: '第308话',
    views: 7600000,
    tags: ['奇幻', '热血', '喜剧'],
    updateTime: '2026-07-03',
  },
  {
    id: 'noblesse',
    title: '大贵族',
    altTitle: 'Noblesse',
    author: '孙济浩 / 李光洙',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20elegant%20Korean%20manhwa%20style%20illustration%20of%20a%20noble%20vampire%20with%20silver%20hair%20and%20red%20eyes%20wearing%20a%20black%20suit%20standing%20in%20a%20gothic%20mansion%20with%20crimson%20roses%20mysterious%20aristocratic%20atmosphere%20clean%20composition&width=400&height=560&seq=comic-cover-007&orientation=portrait',
    rating: 9.5,
    description: '沉睡了820年的贵族——卡迪斯·艾特拉马·迪·莱杰罗在现代世界苏醒。作为拥有绝对力量的"大贵族"，他在一所普通高中里开始了新的生活，但过去的阴影和新的威胁正在逼近...',
    status: '已完结',
    latestChapter: '第544话',
    views: 9500000,
    tags: ['奇幻', '战斗', '校园'],
    updateTime: '2026-06-20',
  },
  {
    id: 'wind-breaker',
    title: '极速风暴',
    altTitle: 'Wind Breaker',
    author: '赵容石',
    category: '运动',
    cover: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Korean%20manhwa%20style%20illustration%20of%20a%20male%20cyclist%20racing%20on%20a%20road%20bike%20at%20high%20speed%20with%20wind%20sweeping%20through%20his%20hair%20urban%20city%20background%20at%20sunset%20orange%20and%20golden%20sky%20dynamic%20motion%20clean%20composition&width=400&height=560&seq=comic-cover-008&orientation=portrait',
    rating: 9.2,
    description: '学霸赵夏民在偶然接触自行车运动后，发现了自己从未体验过的速度与激情。加入学校自行车社后，他不仅要面对强劲的对手，更要在学业和梦想之间找到平衡...',
    status: '连载中',
    latestChapter: '第482话',
    views: 5400000,
    tags: ['运动', '校园', '成长'],
    updateTime: '2026-07-01',
  },
];

export const latestUpdates = [
  {
    id: 'omniscient-reader',
    title: '全知读者视角',
    author: 'Sing N Song / Sleepy-C',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20holding%20a%20glowing%20book%20in%20a%20post%20apocalyptic%20world%20with%20monsters%20in%20the%20background%20dark%20atmospheric%20lighting%20survival%20theme%20clean%20composition&width=400&height=560&seq=comic-cover-009&orientation=portrait',
    rating: 9.7,
    status: '连载中',
    latestChapter: '第210话',
    updateTime: '2026-07-03',
  },
  {
    id: 'return-of-disaster',
    title: '灾难级英雄回归',
    author: 'Redice Studio',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20manhwa%20style%20illustration%20of%20a%20warrior%20with%20fiery%20red%20hair%20and%20scars%20returning%20from%20battle%20wielding%20a%20massive%20sword%20apocalyptic%20background%20with%20flames%20and%20ruins%20epic%20heroic%20pose%20clean%20composition&width=400&height=560&seq=comic-cover-010&orientation=portrait',
    rating: 9.1,
    status: '连载中',
    latestChapter: '第87话',
    updateTime: '2026-07-03',
  },
  {
    id: 'villain-to-kill',
    title: '反派要杀我',
    author: 'Fupin / Eunji',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20contrasting%20Korean%20manhwa%20style%20illustration%20of%20two%20characters%20one%20hero%20in%20white%20and%20one%20villain%20in%20black%20facing%20each%20other%20with%20dramatic%20split%20lighting%20good%20versus%20evil%20theme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-011&orientation=portrait',
    rating: 8.9,
    status: '连载中',
    latestChapter: '第156话',
    updateTime: '2026-07-02',
  },
  {
    id: 'doom-breaker',
    title: '末日破局者',
    author: 'Blue-Deep',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20intense%20Korean%20manhwa%20style%20illustration%20of%20a%20lone%20warrior%20fighting%20against%20shadowy%20monsters%20with%20a%20glowing%20blue%20weapon%20in%20a%20dark%20ravaged%20landscape%20survival%20action%20theme%20dramatic%20lighting%20clean%20composition&width=400&height=560&seq=comic-cover-012&orientation=portrait',
    rating: 9.0,
    status: '连载中',
    latestChapter: '第98话',
    updateTime: '2026-07-02',
  },
];

export const categories = [
  {
    slug: 'reboot',
    name: '热血',
    count: 1280,
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20style%20illustration%20of%20an%20epic%20battle%20scene%20with%20two%20warriors%20clashing%20swords%20surrounded%20by%20flames%20and%20energy%20waves%20action%20packed%20composition%20warm%20orange%20and%20red%20tones%20clean%20simple%20background&width=600&height=800&seq=category-cover-001&orientation=portrait',
    color: 'bg-accent-100',
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    count: 1560,
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20Korean%20manhwa%20style%20illustration%20of%20a%20mystical%20forest%20with%20floating%20crystals%20and%20a%20mage%20casting%20spells%20with%20ethereal%20blue%20and%20purple%20lights%20fantasy%20atmosphere%20clean%20composition&width=600&height=800&seq=category-cover-002&orientation=portrait',
    color: 'bg-secondary-100',
  },
  {
    slug: 'romance',
    name: '恋爱',
    count: 980,
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20couple%20standing%20under%20cherry%20blossom%20trees%20in%20spring%20soft%20pink%20petals%20falling%20gentle%20sunlight%20warm%20and%20sweet%20atmosphere%20clean%20composition&width=600&height=800&seq=category-cover-003&orientation=portrait',
    color: 'bg-accent-50',
  },
  {
    slug: 'school',
    name: '校园',
    count: 720,
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20manhwa%20style%20illustration%20of%20high%20school%20students%20in%20uniforms%20walking%20through%20a%20school%20courtyard%20with%20cherry%20blossoms%20bright%20sunny%20day%20youthful%20energy%20clean%20composition&width=600&height=800&seq=category-cover-004&orientation=portrait',
    color: 'bg-primary-50',
  },
  {
    slug: 'action',
    name: '格斗',
    count: 650,
    cover: 'https://readdy.ai/api/search-image?query=A%20fierce%20Korean%20manhwa%20style%20illustration%20of%20a%20martial%20arts%20fighter%20delivering%20a%20powerful%20kick%20in%20a%20fighting%20arena%20with%20audience%20silhouettes%20dramatic%20spotlight%20intense%20action%20clean%20composition&width=600&height=800&seq=category-cover-005&orientation=portrait',
    color: 'bg-background-100',
  },
  {
    slug: 'sports',
    name: '运动',
    count: 430,
    cover: 'https://readdy.ai/api/search-image?query=A%20energetic%20Korean%20manhwa%20style%20illustration%20of%20athletes%20competing%20on%20a%20sports%20field%20with%20dynamic%20motion%20lines%20sunlight%20streaming%20through%20stadium%20vibrant%20green%20field%20clean%20composition&width=600&height=800&seq=category-cover-006&orientation=portrait',
    color: 'bg-accent-50',
  },
  {
    slug: 'comedy',
    name: '喜剧',
    count: 560,
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20style%20illustration%20of%20characters%20with%20exaggerated%20comedic%20expressions%20in%20a%20colorful%20lively%20setting%20bright%20and%20cheerful%20cartoonish%20style%20clean%20composition&width=600&height=800&seq=category-cover-007&orientation=portrait',
    color: 'bg-primary-50',
  },
  {
    slug: 'thriller',
    name: '悬疑',
    count: 380,
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20style%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20foggy%20alley%20at%20night%20with%20a%20single%20streetlamp%20casting%20long%20shadows%20noir%20atmosphere%20clean%20composition&width=600&height=800&seq=category-cover-008&orientation=portrait',
    color: 'bg-background-100',
  },
];

export const bannerSlides = [
  {
    id: 'banner-1',
    comicId: 'solo-leveling',
    title: '我独自升级',
    subtitle: '从最弱到最强，一人成军的史诗',
    cover: 'https://readdy.ai/api/search-image?query=A%20cinematic%20Korean%20manhwa%20style%20wide%20banner%20illustration%20of%20a%20powerful%20lone%20warrior%20standing%20on%20a%20mountain%20of%20defeated%20enemies%20with%20a%20dark%20army%20of%20shadow%20soldiers%20behind%20him%20dramatic%20epic%20landscape%20with%20storm%20clouds%20and%20lightning%20cinematic%20lighting%20widescreen%20composition&width=1600&height=800&seq=hero-banner-001&orientation=landscape',
    tag: '本周最热',
  },
  {
    id: 'banner-2',
    comicId: 'tower-of-god',
    title: '神之塔',
    subtitle: '登顶之路上，每个选择都关乎生死',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Korean%20manhwa%20style%20wide%20banner%20illustration%20of%20a%20colossal%20mysterious%20tower%20reaching%20into%20the%20clouds%20with%20golden%20light%20emanating%20from%20the%20top%20small%20figures%20climbing%20the%20tower%20fantasy%20epic%20scale%20warm%20golden%20and%20soft%20blue%20tones%20widescreen&width=1600&height=800&seq=hero-banner-002&orientation=landscape',
    tag: '经典必读',
  },
  {
    id: 'banner-3',
    comicId: 'eleceed',
    title: '幻象异能',
    subtitle: '超能力少年的热血成长之路',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20wide%20banner%20illustration%20of%20a%20teenager%20surrounded%20by%20crackling%20electric%20blue%20energy%20with%20a%20cute%20cat%20in%20his%20arms%20urban%20cityscape%20at%20night%20below%20dynamic%20superpower%20effect%20cinematic%20widescreen&width=1600&height=800&seq=hero-banner-003&orientation=landscape',
    tag: '新番强推',
  },
];

export const aboutContent = {
  brandName: '韩漫免费网站',
  brandIntro: '韩漫免费网站成立于2023年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大韩漫爱好者提供最新、最全、最高清的韩漫资源，让每一位读者都能享受到流畅舒适的阅读体验。',
  mission: '我们的使命是打破语言和地域的壁垒，将优质的韩国漫画作品带给每一位中文读者。我们相信，好的故事值得被更多人看到。',
  values: [
    { title: '内容至上', description: '精选优质韩漫，只推值得阅读的好作品，让每一部漫画都能找到它的读者。' },
    { title: '用户体验', description: '高清画质、流畅加载、舒适排版，我们不断优化每一个细节，只为给你最好的阅读体验。' },
    { title: '及时更新', description: '与韩国同步更新，第一时间获取最新章节，让你不再苦苦等待。' },
    { title: '社区共建', description: '打造活跃的读者社区，分享阅读感受，交流漫画心得，一起畅聊韩漫世界。' },
  ],
  stats: [
    { value: '5000+', label: '收录漫画' },
    { value: '300万+', label: '月活用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.9', label: '用户评分' },
  ],
  contact: {
    email: 'hello@lczydmb.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T1-B座 1808室',
    wechat: 'HanManFree',
  },
  reviews: [
    {
      name: '漫画爱好者小王',
      role: '资深读者',
      avatar: 'https://readdy.ai/api/search-image?query=A%20clean%20simple%20portrait%20illustration%20of%20a%20young%20Chinese%20man%20with%20glasses%20friendly%20smile%20minimalist%20style%20solid%20light%20background&width=120&height=120&seq=avatar-reviewer-01&orientation=squarish',
      content: '用了这么多漫画平台，韩漫免费网站的阅读体验是最好的！高清画质加载速度快，而且更新很及时。我追的几部韩漫这里都是第一时间更新。',
      rating: 5,
    },
    {
      name: '樱花漫语',
      role: '韩漫博主',
      avatar: 'https://readdy.ai/api/search-image?query=A%20clean%20simple%20portrait%20illustration%20of%20a%20young%20Chinese%20woman%20with%20long%20hair%20warm%20smile%20minimalist%20style%20solid%20light%20background&width=120&height=120&seq=avatar-reviewer-02&orientation=squarish',
      content: '作为韩漫博主，我推荐这个平台给我的所有粉丝。分类清晰，推荐精准，而且没有烦人的广告弹窗。无删减内容真的太良心了！',
      rating: 5,
    },
    {
      name: '夜雨声烦',
      role: 'VIP会员',
      avatar: 'https://readdy.ai/api/search-image?query=A%20clean%20simple%20portrait%20illustration%20of%20a%20Chinese%20man%20with%20short%20hair%20casual%20look%20minimalist%20style%20solid%20light%20background&width=120&height=120&seq=avatar-reviewer-03&orientation=squarish',
      content: '从高中生追漫到现在工作了还在用，韩漫免费网站真的是我的精神食粮。界面越来越好看，漫画库也越来越全，五星好评！',
      rating: 5,
    },
  ],
  mediaMentions: [
    { name: '动漫之家', quote: '国内韩漫阅读的首选平台，内容丰富更新快。' },
    { name: '漫画人', quote: '用户口碑最好的韩漫网站之一，阅读体验一流。' },
    { name: 'ACG评论', quote: '为韩漫爱好者提供了一个高质量的阅读社区。' },
  ],
};

export const breadcrumbs = {
  home: { name: '首页', path: '/' },
  category: { name: '分类', path: '/category' },
  about: { name: '关于我们', path: '/about' },
};